import * as commonTypes from '../services/siteActionType';
import * as siteprofiletypes from '../siteProfile/services/siteProfileActionType';
import * as unassignedTypes from '../../site/unassignedSiteList/services/unassignedSiteListActionType';
import * as siteListTypes from '../../site/siteList/services/siteListActionType';
import * as sitealismanagement from '../../site/sitealiasmanagement/services/siteAliasActionType'
import * as siteHourlyVolumeShareTypes from '../hourlyVolumeShare/services/hourlyVolumeShareActionType';
import * as editSiteProfileTypes from '../editSiteProfile/services/editSiteProfileActionType';
import initialState from '../../../store/initialState';

const types = {
  ...commonTypes,
  ...siteListTypes,
  ...unassignedTypes,
  ...siteprofiletypes,
  ...sitealismanagement,
  ...siteHourlyVolumeShareTypes,
  ...siteprofiletypes,
  ...editSiteProfileTypes,
};

const siteReducer = (state = initialState.site, action) => {
  switch (action.type) {
    // Fetch Site List
    case types.FETCH_SITE_LIST_REQUEST:
      return {
        ...state,
        isSiteListLoading: true,
        siteListError: null,
      };
    case types.FETCH_SITE_LIST_SUCCESS:
      return {
        ...state,
        isSiteListLoading: false,
        fieldName: action.payload.fieldName || [],
        fieldValues: action.payload.fieldValues || action.payload.data || [],
        isCustomView: action.payload.isCustomView || false,
        siteListError: null,
      };
    case types.FETCH_SITE_LIST_FAILURE:
      return {
        ...state,
        isSiteListLoading: false,
        siteListError: action.payload,
      };

    // Practice Dropdown
    case types.FETCH_PRACTICE_DROPDOWN_REQUEST:
      return {
        ...state,
        isPracticeDropdownLoading: true,
        practiceDropdownError: null,
      };
    case types.FETCH_PRACTICE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isPracticeDropdownLoading: false,
        practiceDropdownData: action.payload,
        practiceDropdownError: null,
      };
    case types.FETCH_PRACTICE_DROPDOWN_FAILURE:
      return {
        ...state,
        isPracticeDropdownLoading: false,
        practiceDropdownError: action.payload,
      };

    // Site Dropdown
    case types.FETCH_SITE_DROPDOWN_REQUEST:
      return {
        ...state,
        isSiteDropdownLoading: true,
        siteDropdownError: null,
      };
    case types.FETCH_SITE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isSiteDropdownLoading: false,
        siteDropdownData: action.payload,
        siteDropdownError: null,
      };
    case types.FETCH_SITE_DROPDOWN_FAILURE:
      return {
        ...state,
        isSiteDropdownLoading: false,
        siteDropdownError: action.payload,
      };

    // Sub Practice Dropdown
    case types.FETCH_SUB_PRACTICE_DROPDOWN_REQUEST:
      return {
        ...state,
        isSubPracticeDropdownLoading: true,
        subPracticeDropdownError: null,
      };
    case types.FETCH_SUB_PRACTICE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isSubPracticeDropdownLoading: false,
        subPracticeDropdownData: action.payload,
        subPracticeDropdownError: null,
      };
    case types.FETCH_SUB_PRACTICE_DROPDOWN_FAILURE:
      return {
        ...state,
        isSubPracticeDropdownLoading: false,
        subPracticeDropdownError: action.payload,
      };

    // Save Bulk Practice Site
    case types.SAVE_BULK_PRACTICE_SITE_REQUEST:
      return {
        ...state,
        isSavingBulkPracticeSite: true,
        saveBulkPracticeSiteError: null,
      };
    case types.SAVE_BULK_PRACTICE_SITE_SUCCESS:
      return {
        ...state,
        isSavingBulkPracticeSite: false,
        saveBulkPracticeSiteError: null,
      };
    case types.SAVE_BULK_PRACTICE_SITE_FAILURE:
      return {
        ...state,
        isSavingBulkPracticeSite: false,
        saveBulkPracticeSiteError: action.payload,
      };

    // Fetch Unassigned Site List
    case unassignedTypes.FETCH_UNASSIGNED_SITE_LIST_REQUEST:
      return {
        ...state,
        isUnassignedSiteListLoading: true,
        unassignedSiteListError: null,
      };
    case unassignedTypes.FETCH_UNASSIGNED_SITE_LIST_SUCCESS:
      return {
        ...state,
        isUnassignedSiteListLoading: false,
        unassignedSiteListData: action.payload,
        unassignedSiteListError: null,
      };
    case unassignedTypes.FETCH_UNASSIGNED_SITE_LIST_FAILURE:
      return {
        ...state,
        isUnassignedSiteListLoading: false,
        unassignedSiteListError: action.payload,
      };

    // Unassigned Practice Dropdown
    case unassignedTypes.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_REQUEST:
      return {
        ...state,
        isPracticeDropdownLoading: true,
        practiceDropdownError: null,
      };
    case unassignedTypes.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isPracticeDropdownLoading: false,
        practiceDropdownData: action.payload,
        practiceDropdownError: null,
      };
    case unassignedTypes.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_FAILURE:
      return {
        ...state,
        isPracticeDropdownLoading: false,
        practiceDropdownError: action.payload,
      };

    // Unassigned Sub Practice Dropdown
    case unassignedTypes.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_REQUEST:
      return {
        ...state,
        isSubPracticeDropdownLoading: true,
        subPracticeDropdownError: null,
      };
    case unassignedTypes.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isSubPracticeDropdownLoading: false,
        subPracticeDropdownData: action.payload,
        subPracticeDropdownError: null,
      };
    case unassignedTypes.FETCH_UNASSIGNED_SUB_PRACTICE_DROPDOWN_FAILURE:
      return {
        ...state,
        isSubPracticeDropdownLoading: false,
        subPracticeDropdownError: action.payload,
      };

    // Unassigned Bulk Save
    case unassignedTypes.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_REQUEST:
      return {
        ...state,
        isSavingBulkPracticeSite: true,
        saveBulkPracticeSiteError: null,
      };
    case unassignedTypes.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_SUCCESS:
      return {
        ...state,
        isSavingBulkPracticeSite: false,
        saveBulkPracticeSiteError: null,
      };
    case unassignedTypes.SAVE_UNASSIGNED_BULK_PRACTICE_SITE_FAILURE:
      return {
        ...state,
        isSavingBulkPracticeSite: false,
        saveBulkPracticeSiteError: action.payload,
      };

    // Practice Dropdown
    case types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_REQUEST:
      return {
        ...state,
        isPracticeDropdownLoading: true,
        practiceDropdownError: null,
      };
    case types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_SUCCESS:
      return {
        ...state,
        isPracticeDropdownLoading: false,
        practiceDropdownData: action.payload,
        practiceDropdownError: null,
      };
    case types.FETCH_UNASSIGNED_PRACTICE_DROPDOWN_FAILURE:
      return {
        ...state,
        isPracticeDropdownLoading: false,
        practiceDropdownError: action.payload,
      };
    //......Site Profile Reducers start......//
    // Fetch Site Profile
    case types.FETCH_SITE_PROFILE_REQUEST:
      return {
        ...state,
        isSiteProfileLoading: true,
        siteProfileError: null,
      };
    case types.FETCH_SITE_PROFILE_SUCCESS:
      return {
        ...state,
        isSiteProfileLoading: false,
        siteProfile: action.payload,
        siteProfileError: null,
      };
    case types.FETCH_SITE_PROFILE_FAILURE:
      return {
        ...state,
        isSiteProfileLoading: false,
        siteProfileError: action.payload,
      };

    // Fetch Site Coverage Hours
    case types.FETCH_SITE_COVERAGE_HOURS_REQUEST:
      return {
        ...state,
        isSiteCoverageHoursLoading: true,
        siteCoverageHoursError: null,
      };
    case types.FETCH_SITE_COVERAGE_HOURS_SUCCESS:
      return {
        ...state,
        isSiteCoverageHoursLoading: false,
        siteCoverageHours: action.payload,
        siteCoverageHoursError: null,
      };
    case types.FETCH_SITE_COVERAGE_HOURS_FAILURE:
      return {
        ...state,
        isSiteCoverageHoursLoading: false,
        siteCoverageHoursError: action.payload,
      };

    // Site Associated Radiologists
    case types.FETCH_SITE_ASSOCIATED_RADS_REQUEST:
      return {
        ...state,
        isSiteAssociatedRadsLoading: true,
        siteAssociatedRadsError: null,
      };
    case types.FETCH_SITE_ASSOCIATED_RADS_SUCCESS:
      return {
        ...state,
        isSiteAssociatedRadsLoading: false,
        siteAssociatedRads: action.payload,
        siteAssociatedRadsError: null,
      };
    case types.FETCH_SITE_ASSOCIATED_RADS_FAILURE:
      return {
        ...state,
        isSiteAssociatedRadsLoading: false,
        siteAssociatedRadsError: action.payload,
      };

    //------------------------------------ Site Alias Management ----------------------------//
    case types.FETCH_SITE_ALIAS_MANAGEMENT_REQUEST:
      return {
        ...state,
        issitealiasmanagementLoading: true,
        sitealiasmanagementData: [],
      };

    case types.FETCH_SITE_ALIAS_MANAGEMENT_SUCCESS:
      return {
        ...state,
        issitealiasmanagementLoading: false,
        sitealiasmanagementData: action.payload.listSiteAliasDetails,
      };

    case types.FETCH_SITE_ALIAS_MANAGEMENT_FAILURE:
      return {
        ...state,
        issitealiasmanagementLoading: false,
        sitealiasmanagementData: [],
      };

    case types.FETCH_GETALLSITES_REQUEST:
      return {
        ...state,
        issitealiasmanagementLoading: true,
        allsitesaliasData: [],
      };

    case types.FETCH_GETALLSITES_SUCCESS:
      return {
        ...state,
        issitealiasmanagementLoading: false,
        allsitesaliasData: action.payload.dropdownItems,
      };

    case types.FETCH_GETALLSITES_FAILURE:
      return {
        ...state,
        issitealiasmanagementLoading: false,
        allsitesaliasData: [],
      };

    case types.EXPORT_SITE_ALIAS_MANAGEMENT_REQUEST:
      return { ...state, issitealiasexporting: true };

    case types.EXPORT_SITE_ALIAS_MANAGEMENT_SUCCESS:
      return { ...state, issitealiasexporting: false };

    case types.EXPORT_SITE_ALIAS_MANAGEMENT_FAILURE:
      return { ...state, issitealiasexporting: false };

    case types.SITEALIASACTIVATEDEACTIVATE_REQUEST:
      return { ...state, issitealiasstatuslaoding: true };
    case types.SITEALIASACTIVATEDEACTIVATE_SUCCESS:
      return { ...state, issitealiasstatuslaoding: false };
    case types.SITEALIASACTIVATEDEACTIVATE_FAILURE:
      return { ...state, issitealiasstatuslaoding: false };

    case types.SITEALIASMANAGEMENT_DETAILS_REQUEST:
      return { ...state, issitealiasHistoryloading: true };
    case types.SITEALIASMANAGEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        issitealiasHistoryloading: false,
        sitealiasHistoryData: action.payload.listSiteAliasDetailHistory,
      };
    case types.SITEALIASMANAGEMENT_DETAILS_FAILURE:
      return { ...state, issitealiasHistoryloading: false };

    case types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_REQUEST:
      return { ...state, issitealiasmanagementbulksaveloading: true };

    case types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_SUCCESS:
      return { ...state, issitealiasmanagementbulksaveloading: false };

    case types.BULK_SAVE_SITE_ALIAS_MANAGEMANT_FAILURE:
      return { ...state, issitealiasmanagementbulksaveloading: false };

    //Site Hourly Volume Share - start
    case types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST:
      return { ...state, isSiteHourlyVolumeShareUnReadLoading: true };
    case types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareUnReadLoading: false,
        siteHourlyVolumeShareUnreadDetails: action.payload || [],
      };
    case types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareUnReadLoading: false,
        siteHourlyVolumeShareUnreadDetails: [],
      };

    case types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST:
      return { ...state, isSiteHourlyVolumeShareReadLoading: true };
    case types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareReadLoading: false,
        siteHourlyVolumeShareReadDetails: action.payload || [],
      };
    case types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareReadLoading: false,
        siteHourlyVolumeShareReadDetails: [],
      };

    case types.GET_DROPDOWN_SITE_RAD_REQUEST:
      return { ...state, isSiteHourlyVolumeShareLoading: true };
    case types.GET_DROPDOWN_SITE_RAD_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        dropdownDetails: action.payload || [],
      };
    case types.GET_DROPDOWN_SITE_RAD_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        dropdownDetails: [],
      };

    case types.GET_WORKLIST_BY_RPCE_ID_REQUEST:
      return { ...state, isSiteHourlyVolumeShareLoading: true };
    case types.GET_WORKLIST_BY_RPCE_ID_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        worklistByRpceId: action.payload || [],
      };
    case types.GET_WORKLIST_BY_RPCE_ID_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        worklistByRpceId: [],
      };

    case types.GET_PRATICES_BY_WORKLIST_ID_REQUEST:
      return { ...state, isSiteHourlyVolumeShareLoading: true };
    case types.GET_PRATICES_BY_WORKLIST_ID_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        praticesByWorklistId: action.payload || [],
      };
    case types.GET_PRATICES_BY_WORKLIST_ID_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        praticesByWorklistId: [],
      };

    case types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST:
      return { ...state, isSiteHourlyVolumeShareLoading: true };
    case types.GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        subPraticesByPraticeId: action.payload || [],
      };
    case types.GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        subPraticesByPraticeId: [],
      };

    case types.GET_SITE_BY_SUB_PRATICE_ID_REQUEST:
      return { ...state, isSiteHourlyVolumeShareLoading: true };
    case types.GET_SITE_BY_SUB_PRATICE_ID_SUCCESS:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        siteBySubPraticeId: action.payload || [],
      };
    case types.GET_SITE_BY_SUB_PRATICE_ID_FAILURE:
      return {
        ...state,
        isSiteHourlyVolumeShareLoading: false,
        siteBySubPraticeId: [],
      };

    case types.EXPORT_SITE_HOURLY_VOLUME_SHARE_REQUEST:
      return { ...state, isSiteHourlyExportLoading: true };
    case types.EXPORT_SITE_HOURLY_VOLUME_SHARE_SUCCESS:
      return { ...state, isSiteHourlyExportLoading: false };
    case types.EXPORT_SITE_HOURLY_VOLUME_SHARE_FAILURE:
      return { ...state, isSiteHourlyExportLoading: false };
    //Site Hourly Volume Share - end

    //common cases
    case types.UPDATE_SITE_REDUCER:
      return { ...state, ...action.payload };

    // Site Calendar Demand
    case types.FETCH_SITE_CALENDAR_DEMAND_REQUEST:
      return {
        ...state,
        isSiteCalendarDemandLoading: true,
        siteCalendarDemandError: null,
      };
    case types.FETCH_SITE_CALENDAR_DEMAND_SUCCESS:
      return {
        ...state,
        isSiteCalendarDemandLoading: false,
        siteCalendarDemand: action.payload,
        siteCalendarDemandError: null,
      };
    case types.FETCH_SITE_CALENDAR_DEMAND_FAILURE:
      return {
        ...state,
        isSiteCalendarDemandLoading: false,
        siteCalendarDemandError: action.payload,
      };

    // Site Calendar Demand By Date
    case types.FETCH_SITE_CALENDAR_DEMAND_BY_DATE_REQUEST:
      return {
        ...state,
        isSiteCalendarDemandByDateLoading: true,
        siteCalendarDemandByDateError: null,
      };
    case types.FETCH_SITE_CALENDAR_DEMAND_BY_DATE_SUCCESS:
      return {
        ...state,
        isSiteCalendarDemandByDateLoading: false,
        siteCalendarDemandByDate: action.payload,
        siteCalendarDemandByDateError: null,
      };
    case types.FETCH_SITE_CALENDAR_DEMAND_BY_DATE_FAILURE:
      return {
        ...state,
        isSiteCalendarDemandByDateLoading: false,
        siteCalendarDemandByDateError: action.payload,
      };

    // Site RADS Demand Schedule Cases
    case types.FETCH_SITE_RADS_DEMAND_SCHEDULE_REQUEST:
      return {
        ...state,
        isSiteRadsDemandScheduleLoading: true,
        siteRadsDemandScheduleError: null,
      };
    case types.FETCH_SITE_RADS_DEMAND_SCHEDULE_SUCCESS:
      return {
        ...state,
        isSiteRadsDemandScheduleLoading: false,
        siteRadsDemandSchedule: action.payload,
        siteRadsDemandScheduleError: null,
      };
    case types.FETCH_SITE_RADS_DEMAND_SCHEDULE_FAILURE:
      return {
        ...state,
        isSiteRadsDemandScheduleLoading: false,
        siteRadsDemandScheduleError: action.payload,
      };

    // Fetch Site Associated RAD Metrics
    case types.FETCH_SITE_ASSOCIATED_RAD_METRICS_REQUEST:
      return {
        ...state,
        isSiteAssociatedRadMetricsLoading: true,
        siteAssociatedRadMetricsError: null,
      };
    case types.FETCH_SITE_ASSOCIATED_RAD_METRICS_SUCCESS:
      return {
        ...state,
        isSiteAssociatedRadMetricsLoading: false,
        siteAssociatedRadMetrics: action.payload,
        siteAssociatedRadMetricsError: null,
      };
    case types.FETCH_SITE_ASSOCIATED_RAD_METRICS_FAILURE:
      return {
        ...state,
        isSiteAssociatedRadMetricsLoading: false,
        siteAssociatedRadMetricsError: action.payload,
      };

    // Fetch Site RAD Metrics Dropdown
    case types.FETCH_SITE_RAD_METRICS_DROPDOWN_REQUEST:
      return {
        ...state,
        isSiteRadMetricsDropdownLoading: true,
        siteRadMetricsDropdownError: null,
      };
    case types.FETCH_SITE_RAD_METRICS_DROPDOWN_SUCCESS:
      return {
        ...state,
        isSiteRadMetricsDropdownLoading: false,
        siteRadMetricsDropdown: action.payload,
        siteRadMetricsDropdownError: null,
      };
    case types.FETCH_SITE_RAD_METRICS_DROPDOWN_FAILURE:
      return {
        ...state,
        isSiteRadMetricsDropdownLoading: false,
        siteRadMetricsDropdownError: action.payload,
      };

    // Export Site Associated RAD Metrics
    case types.EXPORT_SITE_ASSOCIATED_RAD_METRICS_REQUEST:
      return {
        ...state,
        isExportingRadMetrics: true,
        exportRadMetricsError: null,
      };
    case types.EXPORT_SITE_ASSOCIATED_RAD_METRICS_SUCCESS:
      return {
        ...state,
        isExportingRadMetrics: false,
        exportRadMetricsError: null,
      };
    case types.EXPORT_SITE_ASSOCIATED_RAD_METRICS_FAILURE:
      return {
        ...state,
        isExportingRadMetrics: false,
        exportRadMetricsError: action.payload,
      };

    // Site Matrix Child Tables
    case types.FETCH_SITE_MATRIX_CHILD_TABLES_REQUEST:
      return {
        ...state,
        isSiteMatrixChildTablesLoading: true,
        siteMatrixChildTablesError: null,
      };
    case types.FETCH_SITE_MATRIX_CHILD_TABLES_SUCCESS:
      return {
        ...state,
        isSiteMatrixChildTablesLoading: false,
        siteMatrixChildTablesData: action.payload,
        siteMatrixChildTablesError: null,
      };
    case types.FETCH_SITE_MATRIX_CHILD_TABLES_FAILURE:
      return {
        ...state,
        isSiteMatrixChildTablesLoading: false,
        siteMatrixChildTablesError: action.payload,
      };

    // Site Profile Demand By Hours Chart
    case types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_REQUEST:
      return {
        ...state,
        isSiteProfileDemandByHoursChartLoading: true,
        siteProfileDemandByHoursChartError: null,
      };
    case types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_SUCCESS:
      return {
        ...state,
        isSiteProfileDemandByHoursChartLoading: false,
        siteProfileDemandByHoursChartData: action.payload,
        siteProfileDemandByHoursChartError: null,
      };
    case types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_FAILURE:
      return {
        ...state,
        isSiteProfileDemandByHoursChartLoading: false,
        siteProfileDemandByHoursChartError: action.payload,
      };

    // Site Profile Volume By Priority Chart
    case types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_REQUEST:
      return {
        ...state,
        isSiteProfileVolumeByPriorityChartLoading: true,
        siteProfileVolumeByPriorityChartError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_SUCCESS:
      return {
        ...state,
        isSiteProfileVolumeByPriorityChartLoading: false,
        siteProfileVolumeByPriorityChartData: action.payload,
        siteProfileVolumeByPriorityChartError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_FAILURE:
      return {
        ...state,
        isSiteProfileVolumeByPriorityChartLoading: false,
        siteProfileVolumeByPriorityChartError: action.payload,
      };
    // Site Profile Volume By Modality Chart
    case types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_REQUEST:
      return {
        ...state,
        isSiteProfileVolumeByModalityChartLoading: true,
        siteProfileVolumeByModalityChartError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_SUCCESS:
      return {
        ...state,
        isSiteProfileVolumeByModalityChartLoading: false,
        siteProfileVolumeByModalityChartData: action.payload,
        siteProfileVolumeByModalityChartError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_FAILURE:
      return {
        ...state,
        isSiteProfileVolumeByModalityChartLoading: false,
        siteProfileVolumeByModalityChartError: action.payload,
      };

    // Site Profile Metrics Dropdown
    case types.FETCH_SITE_PROFILE_METRICS_DROPDOWN_REQUEST:
      return {
        ...state,
        isSiteProfileMetricsDropdownLoading: true,
        siteProfileMetricsDropdownError: null,
      };
    case types.FETCH_SITE_PROFILE_METRICS_DROPDOWN_SUCCESS:
      return {
        ...state,
        isSiteProfileMetricsDropdownLoading: false,
        siteProfileMetricsDropdown: action.payload,
        siteProfileMetricsDropdownError: null,
      };
    case types.FETCH_SITE_PROFILE_METRICS_DROPDOWN_FAILURE:
      return {
        ...state,
        isSiteProfileMetricsDropdownLoading: false,
        siteProfileMetricsDropdownError: action.payload,
      };

    // Site Profile Demand By Hours Chart Details (Filtered)
    case types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_REQUEST:
      return {
        ...state,
        isSiteProfileDemandByHoursChartDetailsLoading: true,
        siteProfileDemandByHoursChartDetailsError: null,
      };
    case types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteProfileDemandByHoursChartDetailsLoading: false,
        siteProfileDemandByHoursChartDetailsData: action.payload,
        siteProfileDemandByHoursChartDetailsError: null,
      };
    case types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_FAILURE:
      return {
        ...state,
        isSiteProfileDemandByHoursChartDetailsLoading: false,
        siteProfileDemandByHoursChartDetailsError: action.payload,
      };

    // Site Profile Volume By Modality Chart Details (Filtered)
    case types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_REQUEST:
      return {
        ...state,
        isSiteProfileVolumeByModalityChartDetailsLoading: true,
        siteProfileVolumeByModalityChartDetailsError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteProfileVolumeByModalityChartDetailsLoading: false,
        siteProfileVolumeByModalityChartDetailsData: action.payload,
        siteProfileVolumeByModalityChartDetailsError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_FAILURE:
      return {
        ...state,
        isSiteProfileVolumeByModalityChartDetailsLoading: false,
        siteProfileVolumeByModalityChartDetailsError: action.payload,
      };

    // Site Profile Volume By Priority Chart Details (Filtered)
    case types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_REQUEST:
      return {
        ...state,
        isSiteProfileVolumeByPriorityChartDetailsLoading: true,
        siteProfileVolumeByPriorityChartDetailsError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteProfileVolumeByPriorityChartDetailsLoading: false,
        siteProfileVolumeByPriorityChartDetailsData: action.payload,
        siteProfileVolumeByPriorityChartDetailsError: null,
      };
    case types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_FAILURE:
      return {
        ...state,
        isSiteProfileVolumeByPriorityChartDetailsLoading: false,
        siteProfileVolumeByPriorityChartDetailsError: action.payload,
      };

    // Associate RAD to Site
    case types.ASSOCIATE_RAD_TO_SITE_REQUEST:
      return {
        ...state,
        isAssociatingRadToSite: true,
        associateRadToSiteError: null,
      };
    case types.ASSOCIATE_RAD_TO_SITE_SUCCESS:
      return {
        ...state,
        isAssociatingRadToSite: false,
        associateRadToSiteError: null,
      };
    case types.ASSOCIATE_RAD_TO_SITE_FAILURE:
      return {
        ...state,
        isAssociatingRadToSite: false,
        associateRadToSiteError: action.payload,
      };

    // Disassociate RAD from Site
    case types.DISASSOCIATE_RAD_FROM_SITE_REQUEST:
      return {
        ...state,
        isDisassociatingRadFromSite: true,
        disassociateRadFromSiteError: null,
      };
    case types.DISASSOCIATE_RAD_FROM_SITE_SUCCESS:
      return {
        ...state,
        isDisassociatingRadFromSite: false,
        disassociateRadFromSiteError: null,
      };
    case types.DISASSOCIATE_RAD_FROM_SITE_FAILURE:
      return {
        ...state,
        isDisassociatingRadFromSite: false,
        disassociateRadFromSiteError: action.payload,
      };

    // RADs Not Associated To Site (dropdown)
    case types.FETCH_RADS_NOT_ASSOCIATED_TO_SITE_REQUEST:
      return {
        ...state,
        isRadsNotAssociatedLoading: true,
        radsNotAssociatedError: null,
      };
    case types.FETCH_RADS_NOT_ASSOCIATED_TO_SITE_SUCCESS:
      return {
        ...state,
        isRadsNotAssociatedLoading: false,
        radsNotAssociatedToSite: action.payload,
        radsNotAssociatedError: null,
      };
    case types.FETCH_RADS_NOT_ASSOCIATED_TO_SITE_FAILURE:
      return {
        ...state,
        isRadsNotAssociatedLoading: false,
        radsNotAssociatedError: action.payload,
      };
    //......Site Profile Reducers end......//

    // Site Details (Edit Site Profile) STart
    case types.FETCH_SITE_DETAILS_REQUEST:
      return {
        ...state,
        isSiteDetailsLoading: true,
        siteDetailsError: null,
      };
    case types.FETCH_SITE_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteDetailsLoading: false,
        siteDetails: action.payload,
        siteDetailsError: null,
      };
    case types.FETCH_SITE_DETAILS_FAILURE:
      return {
        ...state,
        isSiteDetailsLoading: false,
        siteDetailsError: action.payload,
      };

    // zipcode (Edit Site Profile)
    case types.FETCH_ZIPCODE_DETAILS_REQUEST:
      return {
        ...state,
        zipCode: true,
        zipCodeData: null,
      };
    case types.FETCH_ZIPCODE_DETAILS_SUCCESS:
      return {
        ...state,
        zipCode: false,
        zipCodeData: action.payload,
      };
    case types.FETCH_ZIPCODE_DETAILS_FAILURE:
      return {
        ...state,
        zipCode: false,
        zipCodeData: action.payload,
      };

    // Save Site Details
    case types.SAVE_SITE_DETAILS_REQUEST:
      return {
        ...state,
        isSavingSiteDetails: true,
        saveSiteDetailsError: null,
      };
    case types.SAVE_SITE_DETAILS_SUCCESS:
      return {
        ...state,
        isSavingSiteDetails: false,
        saveSiteDetailsResponse: action.payload,
        saveSiteDetailsError: null,
      };
    case types.SAVE_SITE_DETAILS_FAILURE:
      return {
        ...state,
        isSavingSiteDetails: false,
        saveSiteDetailsError: action.payload,
      };

    // Save Priority SLA
    case types.SAVE_PRIORITY_SLA_REQUEST:
      return {
        ...state,
        isSavingPrioritySla: true,
        savePrioritySlaError: null,
      };
    case types.SAVE_PRIORITY_SLA_SUCCESS:
      return {
        ...state,
        isSavingPrioritySla: false,
        savePrioritySlaResponse: action.payload,
        savePrioritySlaError: null,
      };
    case types.SAVE_PRIORITY_SLA_FAILURE:
      return {
        ...state,
        isSavingPrioritySla: false,
        savePrioritySlaError: action.payload,
      };

    // Save Site Tags
    case types.SAVE_SITE_TAGS_REQUEST:
      return {
        ...state,
        isSaveSiteTagsLoading: true,
        saveSiteTagsError: null,
      };
    case types.SAVE_SITE_TAGS_SUCCESS:
      return {
        ...state,
        isSaveSiteTagsLoading: false,
        saveSiteTagsError: null,
      };
    case types.SAVE_SITE_TAGS_FAILURE:
      return {
        ...state,
        isSaveSiteTagsLoading: false,
        saveSiteTagsError: action.payload,
      };

    // Fetch Sister Sites
    case types.FETCH_SISTER_SITES_REQUEST:
      return {
        ...state,
        isSisterSitesLoading: true,
        sisterSitesError: null,
      };
    case types.FETCH_SISTER_SITES_SUCCESS:
      return {
        ...state,
        isSisterSitesLoading: false,
        sisterSites: action.payload,
        sisterSitesError: null,
      };
    case types.FETCH_SISTER_SITES_FAILURE:
      return {
        ...state,
        isSisterSitesLoading: false,
        sisterSitesError: action.payload,
      };

    // Fetch Site Alias
    case types.FETCH_SITE_ALIAS_REQUEST:
      return {
        ...state,
        isSiteAliasLoading: true,
        siteAliasError: null,
      };
    case types.FETCH_SITE_ALIAS_SUCCESS:
      return {
        ...state,
        isSiteAliasLoading: false,
        siteAlias: action.payload,
        siteAliasError: null,
      };
    case types.FETCH_SITE_ALIAS_FAILURE:
      return {
        ...state,
        isSiteAliasLoading: false,
        siteAliasError: action.payload,
      };

    // Fetch Site Alias History
    case types.FETCH_SITE_ALIAS_HISTORY_REQUEST:
      return {
        ...state,
        isSiteAliasHistoryLoading: true,
        siteAliasHistoryError: null,
      };
    case types.FETCH_SITE_ALIAS_HISTORY_SUCCESS:
      return {
        ...state,
        isSiteAliasHistoryLoading: false,
        siteAliasHistory: action.payload,
        siteAliasHistoryError: null,
      };
    case types.FETCH_SITE_ALIAS_HISTORY_FAILURE:
      return {
        ...state,
        isSiteAliasHistoryLoading: false,
        siteAliasHistoryError: action.payload,
      };

    // Fetch Sister Site History
    case types.FETCH_SISTER_SITE_HISTORY_REQUEST:
      return {
        ...state,
        isSisterSiteHistoryLoading: true,
        sisterSiteHistoryError: null,
      };
    case types.FETCH_SISTER_SITE_HISTORY_SUCCESS:
      return {
        ...state,
        isSisterSiteHistoryLoading: false,
        sisterSiteHistory: action.payload,
        sisterSiteHistoryError: null,
      };
    case types.FETCH_SISTER_SITE_HISTORY_FAILURE:
      return {
        ...state,
        isSisterSiteHistoryLoading: false,
        sisterSiteHistoryError: action.payload,
      };

    // Save Site Alias
    case types.SAVE_SITE_ALIAS_REQUEST:
      return {
        ...state,
        isSavingSiteAlias: true,
        saveSiteAliasError: null,
      };
    case types.SAVE_SITE_ALIAS_SUCCESS:
      return {
        ...state,
        isSavingSiteAlias: false,
        saveSiteAliasResponse: action.payload,
        saveSiteAliasError: null,
      };
    case types.SAVE_SITE_ALIAS_FAILURE:
      return {
        ...state,
        isSavingSiteAlias: false,
        saveSiteAliasError: action.payload,
      };

    // Fetch Model Input Files
    case types.FETCH_MODEL_INPUT_FILES_REQUEST:
      return {
        ...state,
        isModelInputFilesLoading: true,
        modelInputFilesError: null,
      };
    case types.FETCH_MODEL_INPUT_FILES_SUCCESS:
      return {
        ...state,
        isModelInputFilesLoading: false,
        modelInputFiles: action.payload,
        modelInputFilesError: null,
      };
    case types.FETCH_MODEL_INPUT_FILES_FAILURE:
      return {
        ...state,
        isModelInputFilesLoading: false,
        modelInputFilesError: action.payload,
      };

    // Fetch Site Model Filter (Overall Priority / Modality Mix)
    case types.FETCH_SITE_MODEL_FILTER_REQUEST:
      return {
        ...state,
        isSiteModelFilterLoading: true,
        siteModelFilterError: null,
      };
    case types.FETCH_SITE_MODEL_FILTER_SUCCESS:
      return {
        ...state,
        isSiteModelFilterLoading: false,
        siteModelFilterData: action.payload,
        siteModelFilterError: null,
      };
    case types.FETCH_SITE_MODEL_FILTER_FAILURE:
      return {
        ...state,
        isSiteModelFilterLoading: false,
        siteModelFilterError: action.payload,
      };

    // Save Site Model Input
    case types.SAVE_SITE_MODEL_INPUT_REQUEST:
      return {
        ...state,
        isSavingSiteModelInput: true,
        saveSiteModelInputError: null,
      };
    case types.SAVE_SITE_MODEL_INPUT_SUCCESS:
      return {
        ...state,
        isSavingSiteModelInput: false,
        saveSiteModelInputResponse: action.payload,
        saveSiteModelInputError: null,
      };
    case types.SAVE_SITE_MODEL_INPUT_FAILURE:
      return {
        ...state,
        isSavingSiteModelInput: false,
        saveSiteModelInputError: action.payload,
      };

    // Fetch Priority / Subspeciality Split
    case types.FETCH_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST:
      return {
        ...state,
        isPrioritySubspecialitySplitLoading: true,
        prioritySubspecialitySplitError: null,
      };
    case types.FETCH_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS:
      return {
        ...state,
        isPrioritySubspecialitySplitLoading: false,
        prioritySubspecialitySplitData: action.payload,
        prioritySubspecialitySplitError: null,
      };
    case types.FETCH_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE:
      return {
        ...state,
        isPrioritySubspecialitySplitLoading: false,
        prioritySubspecialitySplitError: action.payload,
      };

    // Save Priority / Subspeciality Split
    case types.SAVE_PRIORITY_SUBSPECIALITY_SPLIT_REQUEST:
      return {
        ...state,
        isSavingPrioritySubspecialitySplit: true,
        savePrioritySubspecialitySplitError: null,
      };
    case types.SAVE_PRIORITY_SUBSPECIALITY_SPLIT_SUCCESS:
      return {
        ...state,
        isSavingPrioritySubspecialitySplit: false,
        savePrioritySubspecialitySplitResponse: action.payload,
        savePrioritySubspecialitySplitError: null,
      };
    case types.SAVE_PRIORITY_SUBSPECIALITY_SPLIT_FAILURE:
      return {
        ...state,
        isSavingPrioritySubspecialitySplit: false,
        savePrioritySubspecialitySplitError: action.payload,
      };

    // Check Priority / Subspeciality Config Availability
    case types.CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_REQUEST:
      return {
        ...state,
        isCheckingPrioritySubspecialityConfigBySiteId: true,
        prioritySubspecialityConfigBySiteIdError: null,
      };
    case types.CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_SUCCESS:
      return {
        ...state,
        isCheckingPrioritySubspecialityConfigBySiteId: false,
        prioritySubspecialityConfigBySiteIdData: action.payload,
        prioritySubspecialityConfigBySiteIdError: null,
      };
    case types.CHECK_PRIORITY_SUBSPECIALITY_CONFIG_BY_SITEID_FAILURE:
      return {
        ...state,
        isCheckingPrioritySubspecialityConfigBySiteId: false,
        prioritySubspecialityConfigBySiteIdError: action.payload,
      };

    // Upload Site Model Input File
    case types.SITE_MODEL_INPUT_UPLOAD_REQUEST:
      return {
        ...state,
        isUploadingModelInputFile: true,
        uploadModelInputError: null,
      };
    case types.SITE_MODEL_INPUT_UPLOAD_SUCCESS:
      return {
        ...state,
        isUploadingModelInputFile: false,
        uploadModelInputResponse: action.payload,
        uploadModelInputError: null,
      };
    case types.SITE_MODEL_INPUT_UPLOAD_FAILURE:
      return {
        ...state,
        isUploadingModelInputFile: false,
        uploadModelInputError: action.payload,
      };

    // Download Site Model Input Template
    case types.DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_REQUEST:
      return {
        ...state,
        isDownloadingSiteModelInputTemplate: true,
        downloadSiteModelInputTemplateError: null,
      };
    case types.DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_SUCCESS:
      return {
        ...state,
        isDownloadingSiteModelInputTemplate: false,
        downloadSiteModelInputTemplateResponse: action.payload,
        downloadSiteModelInputTemplateError: null,
      };
    case types.DOWNLOAD_SITE_MODEL_INPUT_TEMPLATE_FAILURE:
      return {
        ...state,
        isDownloadingSiteModelInputTemplate: false,
        downloadSiteModelInputTemplateError: action.payload,
      };
    // Site Details (Edit Site Profile) End
    case types.FETCH_SITE_ONBOARDING_DETAILS_REQUEST:
      return { ...state, isSiteDetailsLoading: true };
    case types.FETCH_SITE_ONBOARDING_DETAILS_SUCCESS:
      return {
        ...state,
        isSiteDetailsLoading: false,
        siteOnboardingDetails: action.payload?.values || [],
      };
    case types.FETCH_SITE_ONBOARDING_DETAILS_FAILURE:
      return {
        ...state,
        isSiteDetailsLoading: false,
        siteOnboardingDetails: [],
      };

    // State list (scheduling state dropdown)
    case types.FETCH_STATE_LIST_REQUEST:
      return { ...state, isStateListLoading: true };
    case types.FETCH_STATE_LIST_SUCCESS:
      return { ...state, isStateListLoading: false, stateList: action.payload };
    case types.FETCH_STATE_LIST_FAILURE:
      return { ...state, isStateListLoading: false, stateList: [] };

    case types.UPDATE_SITE_STATE_REQUEST:
      return { ...state, isSiteStateUpdating: true };
    case types.UPDATE_SITE_STATE_SUCCESS:
      return { ...state, isSiteStateUpdating: false };
    case types.UPDATE_SITE_STATE_FAILURE:
      return { ...state, isSiteStateUpdating: false };

        // Site Rad Assignment Notes
        case types.FETCH_SITE_RAD_NOTES_REQUEST:
            return { ...state, isRadSiteAssignmentNotesLoading: true };

        case types.FETCH_SITE_RAD_NOTES_SUCCESS:
            return {
                ...state,
                isRadSiteAssignmentNotesLoading: false,
                radSiteAssignmentNotesList: action.payload || [],
            };

        case types.FETCH_SITE_RAD_NOTES_FAILURE:
            return {
                ...state,
                isRadSiteAssignmentNotesLoading: false,
                radSiteAssignmentNotesList: [],
            };

        case types.FETCH_SITE_RAD_ALL_NOTES_REQUEST:
          return { ...state, isAllRadSiteAssignmentNotesLoading: true };

        case types.FETCH_SITE_RAD_ALL_NOTES_SUCCESS:
          return {
            ...state,
            isAllRadSiteAssignmentNotesLoading: false,
            allRadSiteAssignmentNotesList: action.payload || [],
          };

        case types.FETCH_SITE_RAD_ALL_NOTES_FAILURE:
          return {
            ...state,
            isAllRadSiteAssignmentNotesLoading: false,
            allRadSiteAssignmentNotesList: [],
          };

        case types.ADD_SITE_RAD_NOTE_REQUEST:
            return { ...state, isAddRadSiteAssignmentNoteLoading: true };

        case types.ADD_SITE_RAD_NOTE_SUCCESS:
            return {
                ...state,
                isAddRadSiteAssignmentNoteLoading: false,
                addRadSiteAssignmentNoteSuccess: true,
            };

        case types.ADD_SITE_RAD_NOTE_FAILURE:
            return { ...state, isAddRadSiteAssignmentNoteLoading: false };

        case types.CLEAR_SITE_RAD_NOTES:
            return {
                ...state,
                radSiteAssignmentNotesList: [],
                isRadSiteAssignmentNotesLoading: false,
            };

        case types.CLEAR_SITE_RAD_ALL_NOTES:
          return {
            ...state,
            allRadSiteAssignmentNotesList: [],
            isAllRadSiteAssignmentNotesLoading: false,
          };

        case types.RESET_ADD_SITE_RAD_NOTE_SUCCESS:
            return { ...state, addRadSiteAssignmentNoteSuccess: false };

        default:
            return state;
    }
};

export default siteReducer;
